
const digest = 'cc385875a1fe41d62f622667230d7214ea9f72394ce25c0e4f2758fc1581cd52';
const classes = {"wrapper":"_wrapper_mlyum_1","input":"_input_mlyum_4","iconWrapper":"_iconWrapper_mlyum_17","description":"_description_mlyum_32"};
const css = `._wrapper_mlyum_1 {
  position: relative;
}
._wrapper_mlyum_1 ._input_mlyum_4 {
  border: 1px solid #c1cbe4 !important;
  min-height: 55px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 15px;
  box-shadow: inset 0 3px 0 0 rgba(198, 214, 240, 0.5);
  padding: 16px 40px 16px 20px !important;
  color: #000;
  background-color: #dce7fa;
  position: relative;
  width: 100%;
}
._wrapper_mlyum_1 ._iconWrapper_mlyum_17 {
  height: 25px;
  width: 30px;
  background-color: #ffffff;
  position: absolute;
  right: 20px;
  top: calc(50% - 12px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
._wrapper_mlyum_1 ._iconWrapper_mlyum_17 img {
  height: 16px;
  cursor: pointer;
}
._wrapper_mlyum_1 ._description_mlyum_32 {
  font-size: 12px;
  opacity: 0.6;
  margin-top: 3px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  